import { render, staticRenderFns } from "./popoverMenuRadio.vue?vue&type=template&id=5b98745e&scoped=true"
import script from "./popoverMenuRadio.vue?vue&type=script&lang=js"
export * from "./popoverMenuRadio.vue?vue&type=script&lang=js"
import style0 from "./popoverMenuRadio.vue?vue&type=style&index=0&id=5b98745e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b98745e",
  null
  
)

export default component.exports